module.exports = __webpack_public_path__ + "img/2.46e7de29.png";